export default "__VITE_ASSET__cce2c18d__"